import { createFileRoute } from "@tanstack/react-router";
import PrivateListingMethod from "@/pages/PrivateListingMethod";

export const Route = createFileRoute("/de/vinde-masina/metoda/")({
  head: () => ({
    meta: [
      { title: "Wähle, wie du dein Inserat erstellst | RO Auto Market" },
      {
        name: "description",
        content:
          "Fülle das Inserat manuell aus oder lass die KI es aus einem Video deines Autos erstellen. Du prüfst alles vor der Veröffentlichung.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Wähle, wie du dein Inserat erstellst" },
      {
        property: "og:description",
        content: "Manuelles Inserat oder KI-Erstellung aus Video, je nach gewähltem Paket.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PrivateListingMethod,
});
